'use client';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import Typography from '@egalite/ui/Typography';

import ButtonsPages from './legacy_blocks/ButtonsPages';
import ErrorList from '@egalite/ui/ErrorList';
import { useEffect, useState } from 'react';

import { InputField } from '@egalite/ui/Form';
import {
	physicalDisability,
	hearingImpairment,
	visualImpairment,
	rehabilitationINSS,
	intellectualDisability,
	autismSpectrum,
	psychosocialDisability,
} from './disabilityDataFormSteps';
import { useRouter, useSearchParams } from 'next/navigation';
import BooleanRadioGroup from '@egalite/ui/Form/BooleanRadioGroup';
import CheckboxGroup from '@egalite/ui/Form/CheckboxGroup';
import { useSnapshot } from 'valtio';
import useMultiStepForm from '../../lib/hooks/useMultiStepForm';
import Flex from '@egalite/ui/Utils/Flex';

import save from './save';
import { useNotification } from '@egalite/ui/IncluiPCD/NotificationProvider';
import authFetch from '../../lib/auth/authFetch';
import Cookies from 'js-cookie';
import FormPage from './legacy_blocks/CandidateFormPage';
import Loading from '@egalite/ui/Loading';
import Button from '@egalite/ui/Buttons';

const mapTypes = {
	'Deficiência Física': physicalDisability,
	'Deficiência Auditiva': hearingImpairment,
	'Deficiência Visual': visualImpairment,
	'Deficiência Intelectual': intellectualDisability,
	'Deficiência Psicossocial': psychosocialDisability,
	'Transtorno do Espectro Autista': autismSpectrum,
	'Reabilitado do INSS': rehabilitationINSS,
};
const getDisabilityStepsFromType = disability => {
	return mapTypes[disability] || '';
};
function Form({ edit = false }) {
	const router = useRouter();

	const notification = useNotification();
	const [loadingData, setLoadingData] = useState(true);
	const [candidateData, setCandidateData] = useState(null);
	const searchParams = useSearchParams();

	const {
		isReady,
		formController,
		getFieldProps,
		loading,
		submitting,
		success,
		errors,
		data,

		actualStep,
		title,
		label,

		goPrev,
		setMultistepData,
	} = useMultiStepForm({
		storeData: candidateData,
		mutation: data => save('/api/v1/candidate/disabilityDataDescription', data),
		// showSignLanguage: storeSnap.data?.disability[router.query?.n]?.disabilityType === 'Deficiência Auditiva',
		nextRoute: '/candidato/form/disabilityDataUpload',
	});

	useEffect(() => {
		if (loadingData) {
			authFetch('/api/v2/candidate/profile', Cookies.get('token'))
				.then(res => res.json())
				.then(data => {
					setLoadingData(false);
					if (data.success === true) {
						setCandidateData(data.data);
						const n = searchParams.get('n');

						if (n != null && data.data != null && !isReady) {
							const newDisability = getDisabilityStepsFromType(data.data?.disability[n]?.disabilityType);
							setMultistepData({
								multistepData: newDisability,
								prevRoute: '/candidato/form/disabilityData?n=' + n,
								storeData: data.data,
							});
						}
					} else {
						notification.error('Erro ao carregar dados do candidato');
					}
				});
		}
	}, [formController, router, loadingData, notification, searchParams, isReady, setMultistepData]);

	if (loadingData || !isReady || actualStep === 'start' || actualStep === 'finish') {
		return <Loading fullScreen={true}>carregando dados</Loading>;
	}

	return (
		<FormPage
			actualStep={4}
			formActualStep={1}
			formTotalSteps={2}
			progress={50}
			formTitle={'Dados da Deficiência'}
			// previousForm="/"
			showStepsMenu={false}
			// showBackButton={false}
			modal={edit}
		>
			<form onSubmit={formController.handleSubmit}>
				<div className="mb-16 md:mb-24">
					<Typography variant="headline-5" className="text-brand-main mb-12">
						{title}
					</Typography>
					{actualStep.type === 'boolean' ? (
						<BooleanRadioGroup
							label={actualStep.label}
							{...getFieldProps({ name: actualStep.field, type: 'checkbox' })}
						/>
					) : null}
					{actualStep.type === 'check' ? (
						<CheckboxGroup
							singleColumn={true}
							label={actualStep.label}
							options={actualStep.choices}
							{...getFieldProps({ name: actualStep.field, type: 'checkbox' })}
						/>
					) : null}
					{actualStep.type === 'textarea' ? (
						<InputField
							label={actualStep.label}
							id={actualStep.field}
							multiline={true}
							type="text"
							{...getFieldProps({ name: actualStep.field })}
						/>
					) : null}

					{/* <ErrorList errors={formController.errors} touched={formController.touched} /> */}
					{errors != null &&
						errors.map((err, index) => (
							<Typography key={`err-${index}`} variant="body2" color="error.dark">
								{err}
							</Typography>
						))}
					<div className="md:mt-24 mt-16">
						{edit ? (
							<Button type="submit" variant="primary" className="w-full">
								Salvar
							</Button>
						) : (
							<ButtonsPages
								submitDisabled={
									submitting ||
									formController.values == null ||
									formController.values[actualStep.field] == null ||
									(formController.values && formController.values[actualStep.field]?.length === 0)
								}
								previousForm={goPrev}
							/>
						)}
					</div>
				</div>
			</form>
		</FormPage>
	);
}

export default Form;
